import React from 'react'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import { Button } from '@/components/button'
import { Row, Col, Input, Alert } from 'reactstrap'
import Resx from '@/components/Resx'
import getComponentKey from '@/utils/getComponentKey'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import isEnterPressed from '@/utils/isEnterPressed'

const minimumLength = 2

class MinimumLengthSearchList extends React.Component {
  state = {
    inputContent: '',
    searchExpression: '',
    lastReloadedAt: getComponentKey()
  }

  search = () => {
    if (this.state.inputContent.length >= minimumLength) {
      this.setState({
        searchExpression: this.state.inputContent,
        lastReloadedAt: getComponentKey()
      })
    }
  }
  _renderGrid () {
    if (this.state.searchExpression.length >= minimumLength) {
      return <div className='mt-2'>{this.renderGrid()}</div>
    } else {
      return null
    }
  }
  render () {
    const { localize } = this.props
    const isValid = this.state.inputContent.length >= minimumLength
    return (
      <Main>
        <MainTop>
          <MainTopTitle><Resx name={this.getTitle()} /></MainTopTitle>
          <MainTopLeft>
            <CreateChangeItem buttonText={this.getCreateNewButtonText()} scope={this.getScope()} />
          </MainTopLeft>
        </MainTop>
        <MainBody>
          <Row>
            <Col sm='6'>
              <Input
                value={this.state.inputContent}
                onChange={e => this.setState({ inputContent: e.target.value })}
                onKeyDown={evt => isEnterPressed(evt) && this.search()} />
            </Col>
            <Col sm='2'>
              <Button
                color='primary'
                icon='refresh'
                disabled={!isValid}
                onClick={this.search}><Resx name='Common.Search' /></Button>
            </Col>
          </Row>
          {!isValid && <Alert className='mt-2' color='warning'>{localize('Blacklists.EnterAtLeastTwoChars')}</Alert>}
          {this._renderGrid()}
        </MainBody>
      </Main>
    )
  }
}

export {
  MinimumLengthSearchList
}



// WEBPACK FOOTER //
// ./src/internal-app/components/minimumLengthSearchList.js